import { getBrowserInfo } from './browser-detection';

export * from './http';
export * from './dates';
export * from './entity';
export * from './error-codes';
export * from './invite';
export * from './items';
export * from './item-definitions';
export * from './keycodes';
export * from './session';
export * from './states';

export const APPLICATION_NAME = 'mover';

export const EVENTS = {
  MOVE_ITEM_UPDATED: 'event.move-item-updated',
  USER_CREATED: 'event.user-created',
  USER_UPDATED: 'event.user-updated',
  SESSION_UPDATED: 'event.session-updated',
  SESSION_DELETED: 'event.session-deleted',
  SESSION_HEADERS_RECEIVED: 'event.session-headers-received',
  SIGNED_IN: 'event.sign-in',
  SIGNED_OUT: 'event.sign-out',
  SIGNED_UP: 'event.sign-up',
  INVITE_SET: 'event.invite-set',
  SITE_CONFIG_UPDATED: 'event.site-config-updated',
  CURRENT_USER_UPDATED: 'event.current-user-updated',
  CURRENT_MOVE_UPDATED: 'event.current-move-updated',
  NO_AUTH: 'event.no-auth',
  INVITE_NOT_FOUND: 'event.invite-not-found',
};

// https://stackoverflow.com/a/4819886/89594
// `typeof window` check is to keep Node from throwing (Protractor).
export const IS_TOUCH_DEVICE = !!(
  typeof window !== 'undefined' &&
  ('ontouchstart' in window || navigator.maxTouchPoints)
);

export const IS_IE = getBrowserInfo().name === 'ie';

// Height of the fixed header + subheader, below which is the content
export const SCROLL_OFFSET = 100;

// TODO: Explore using https://momentjs.com/docs/#/i18n/locale-data/
export const MONTHS_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const USPS_SUFFIXES = [
  '',
  'ATTY',
  'CEO',
  'CFO',
  'CIO',
  'CPA',
  'DC',
  'DDS',
  'DO',
  'DVM',
  'ESQ',
  'I',
  'II',
  'III',
  'IV',
  'V',
  'JR',
  'MD',
  'PHD',
  'PRES',
  'RET',
  'SR',
  'VP',
];
